{
  "help": "Yardım",
  "info": "Bilgiler"
}
